import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ApiEndpoint, ServiceModalName } from '@enums';
import { useAppDispatch } from '@hooks';
import { Event } from '@services';
import {
  clearCheckBox,
  fetchFormList,
  removeServiceModal,
  resetCurrentForm,
  resetFormFilter,
  resetFormPagination,
} from '@store';
import type { FormPayload } from '@types';

interface UseFetchFormListProps extends FormPayload {
  isFormInit?: boolean;
  additionalDeps?: any[];
  customClearFunction?: any;
  hookOptions?: {
    resetFormTrigger?: boolean;
    custom?: {
      condition?: boolean;
      dependencies?: any;
    };
  };
}

export const useFetchFormList = ({
  formType,
  endpoint = ApiEndpoint.DEFAULT,
  params,
  globalOptions,
  callbackFunction,
  hookOptions = {
    resetFormTrigger: true,
    custom: { condition: true, dependencies: [] },
  },
  additionalDeps,
}: UseFetchFormListProps) => {
  const dispatch = useAppDispatch();
  const { key } = useLocation();

  const deps = hookOptions.resetFormTrigger
    ? additionalDeps ?? [params?.application_id, key]
    : hookOptions.custom?.dependencies ?? [];

  useEffect(() => {
    const getFormList = dispatch(
      fetchFormList({
        formType,
        params,
        globalOptions,
        callbackFunction,
      }),
    );

    hookOptions?.custom?.condition && Event.subscribe(removeServiceModal(ServiceModalName.FormModal), getFormList);

    return () => Event.unsubscribe(removeServiceModal(ServiceModalName.FormModal), getFormList);
  }, deps);

  useEffect(() => {
    return () => {
      if (globalOptions?.pagination) {
        hookOptions.resetFormTrigger && dispatch(resetCurrentForm(formType));
        dispatch(clearCheckBox({ formType, endpoint }));
        dispatch(resetFormPagination(formType));
        dispatch(resetFormFilter({ formType }));
      }
    };
  }, [formType]);
};
